export default [
    {
        title: "Denver, Colorado",
        location: "United States",
        googleMapsUrl: "https://www.google.com/maps/place/Denver,+CO/@39.7644863,-105.0199178,11z/data=!3m1!4b1!4m6!3m5!1s0x876b80aa231f17cf:0x118ef4f8278a36d6!8m2!3d39.7392358!4d-104.990251!16zL20vMDJjbDE?entry=ttu",
        startDate: "04 May, 2021",
        endDate: "10 May, 2021",
        description: "Denver, Colorado, a mile-high urban gateway to the Rocky Mountains, entices with its dynamic arts scene, outdoor adventure, and a laid-back mountain-city vibe.",
        imageUrl: "denver.jpeg"
    },
    {
        title: "Austin, Texas",
        location: "United States",
        googleMapsUrl: "https://www.google.com/maps/place/Austin,+TX/@30.3079541,-97.9205501,11z/data=!3m1!4b1!4m6!3m5!1s0x8644b599a0cc032f:0x5d9b464bd469d57a!8m2!3d30.267153!4d-97.7430608!16zL20vMHZ6bQ?entry=ttu",
        startDate: "01 May, 2021",
        endDate: "04 May, 2021",
        description: "Austin, Texas, a vibrant city at the heart of the Lone Star State, harmonizes live music, tech innovation, and outdoor splendor along the shores of the Colorado River.",
        imageUrl: "austin.jpeg"
    },
    {
        title: "Los Angeles, California",
        location: "United States",
        googleMapsUrl: "https://www.google.com/maps/place/Los+Angeles,+CA/@34.020479,-118.4117325,10z/data=!4m6!3m5!1s0x80c2c75ddc27da13:0xe22fdf6f254608f4!8m2!3d34.0549076!4d-118.242643!16s%2Fm%2F030qb3t",
        startDate: "10 August, 2019",
        endDate: "17 August, 2019",
        description: "Los Angeles, a sprawling metropolis nestled between mountains and ocean, captivates with its blend of Hollywood glamour, diverse neighborhoods, and year-round sunshine.",
        imageUrl: "la.jpeg"
    },
]